let base = window._env_.VUE_APP_ADMIN_HOST

export const queryAudioAsrCheckTemplate = params => {
  return axios.post(`${base}/audio_asr_check_template/query`, params)
}

export const queryAudioAsrCheckTemplateSelect = params => {
  return axios.post(`${base}/audio_asr_check_template/query_select`, params)
}

export const getAudioAsrCheckTemplate = params => {
  return axios.get(`${base}/audio_asr_check_template/get_${params.id}`, { params })
}

export const createAudioAsrCheckTemplate = params => {
  return axios.post(`${base}/audio_asr_check_template/create`, params)
}

export const updateAudioAsrCheckTemplate = params => {
  const { id, ...rest } = params
  return axios.post(`${base}/audio_asr_check_template/edit_${id}`, rest)
}

export const deleteAudioAsrCheckTemplate = id => {
  return axios.post(`${base}/audio_asr_check_template/delete_${id}`)
}

export const copyAudioAsrCheckTemplate = id => {
  return axios.post(`${base}/audio_asr_check_template/copy_${id}`)
}

export const getAudioAsrCheckPromptConfig = params => {
  return axios.post(`${base}/audio_asr_check_template/prompt_config`, params || {})
}

export const previewAudioAsrCheckPrompt = params => {
  return axios.post(`${base}/audio_asr_check_template/preview_prompt`, params)
}

export const getAudioAsrCheckBindBySubstep = params => {
  return axios.get(`${base}/audio_asr_check_template_bind/get_by_substep_${params.substepid}`, { params })
}

export const listAudioAsrCheckBindByTemplate = params => {
  return axios.get(`${base}/audio_asr_check_template_bind/list_by_template_${params.id}`, { params })
}

export const bindAudioAsrCheckTemplate = params => {
  return axios.post(`${base}/audio_asr_check_template_bind/bind`, params)
}

export const unbindAudioAsrCheckTemplate = substepid => {
  return axios.post(`${base}/audio_asr_check_template_bind/unbind_${substepid}`)
}

export const queryAudioAsrCheckOrderResult = params => {
  return axios.post(`${base}/audio_asr_check_order_result/query`, params)
}

export const queryAudioAsrCheckOrderResultSummary = params => {
  return axios.post(`${base}/audio_asr_check_order_result/summary`, params)
}

export const recheckAudioAsrCheckOrderResult = params => {
  return axios.post(`${base}/audio_asr_check_order_result/recheck_${params.orderid}`, params)
}

export const queryAudioAsrCheckProjectStats = params => {
  return axios.post(`${base}/audio_asr_check_project_stats/query`, params)
}

export const resetAudioAsrCheckProjectLlm = params => {
  return axios.post(`${base}/audio_asr_check_project_stats/reset_llm`, params)
}



// WEBPACK FOOTER //
// ./src/views/audio-asr-check/audio-asr-check.api.js